module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Shield-check-6981152273b245e8c4f6890f540ceb88.svg";